// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Transaction-secondContainer-c8Q4W {
    width: 100%;
    max-width: 783px;
    overflow-x: auto;
    overflow-y: hidden;
}

@media screen and (min-width:1281px) {
    .Transaction-transactionGrid-QPuWe {
        grid-template-columns: 267px 783px;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/transaction/Transaction.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,kCAAkC;IACtC;AACJ","sourcesContent":[".secondContainer {\n    width: 100%;\n    max-width: 783px;\n    overflow-x: auto;\n    overflow-y: hidden;\n}\n\n@media screen and (min-width:1281px) {\n    .transactionGrid {\n        grid-template-columns: 267px 783px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secondContainer": `Transaction-secondContainer-c8Q4W`,
	"transactionGrid": `Transaction-transactionGrid-QPuWe`
};
module.exports = ___CSS_LOADER_EXPORT___;
